import React from 'react';
import Link from 'gatsby-link';
import Icon from '../Icon';

import './site-navigation.css';

class SiteNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  showNavigation = () => {
    this.setState({ isOpen: true });
    document.addEventListener('click', this.hideNavigation);
  };

  hideNavigation = () => {
    document.removeEventListener('click', this.hideNavigation);
    this.setState({ isOpen: false });
  };

  render() {
    const menuClass = `site-nav--menu ${this.state.isOpen ? 'open' : ''}`;

    return (
      <nav className="site-nav" id="nav-primary" aria-label="Main navigation">
        <h2 className="is-sr">Main navigation</h2>
        <Icon
          type="IconMenu"
          color="#fff"
          height="24"
          width="24"
          label="Menu"
          className="site-nav--head"
          iconClassName="site-nav--icon"
          labelClassName="site-nav--label"
          onClick={this.showNavigation}
        />
        <ul id="menu-primary-navigation" className={menuClass}>
          <li className="site-nav--menu-item">
            <Link to="/">Home</Link>
          </li>
          <li className="site-nav--menu-item">
            <Link to="/blog" title="Read the blog">
              Blog
            </Link>
          </li>
          <li className="site-nav--menu-item">
            <Link to="/resume" title="View my resume">
              Resume
            </Link>
          </li>
          <li className="site-nav--menu-item">
            <Link to="/contact" title="Contact me">
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default SiteNavigation;



// WEBPACK FOOTER //
// ./src/components/SiteNavigation/index.js